module.exports = __webpack_public_path__ + "img/pr-20.443ab75e.png";